import { AxiosError } from "axios";
import { ADMIN_API_ENDPOINTS } from "@/config/apiEndpoints/adminUrls";
import { handleApiError } from "@/lib/utils";
import adminAxios from "@/lib/axios";

export interface IPlacements {
  id?: number;
  page_id?: number;
  component_id?: number;
  title?: string;
  title_color?: string;
  background_color?: string;
  scroll_frequency?: number;
  status?: boolean;
  variant?: string;
  // Placements 2 variant fields
  desktop_background_color?: string;
  mobile_background_color?: string;
  backvariant?: string;
  gradient_color_1?: string;
  gradient_color_2?: string;
  gradient_color_3?: string;
  gradient_color_4?: string;
  button_text?: string;
  button_text_color?: string;
  button_color?: string;
  metadata?: any[];
  // Placements 3 variant fields (two rows with scrolling strip images)
  section_background_color?: string;
  row1_image?: string;
  row2_image?: string;
  row1_scroll_frequency?: number;
  row2_scroll_frequency?: number;
  row1_scroll_direction?: string;
  row2_scroll_direction?: string;
  // Placements 4 variant fields (dynamic marquee rows with per-row icons)
  rows_config?: any[];
}

export async function createPlacements(payload: Partial<IPlacements>) {
  try {
    const response = await adminAxios.post(
      ADMIN_API_ENDPOINTS.PLACEMENTS.CREATE,
      payload
    );
    return response?.status === 201 ? response?.data : null;
  } catch (error) {
    const errorResponse = handleApiError(error as AxiosError);
    return errorResponse ? errorResponse : null;
  }
}

export async function updatePlacements(id: number, payload: Partial<IPlacements>) {
  try {
    const response = await adminAxios.put(
      ADMIN_API_ENDPOINTS.PLACEMENTS.UPDATE(id),
      payload
    );
    return response?.status === 200 ? response?.data : null;
  } catch (error) {
    const errorResponse = handleApiError(error as AxiosError);
    return errorResponse ? errorResponse : null;
  }
}
